<template>
  <div>
    <div class="materials">
      <v-category-button v-for='material in materials[listType]'
        @click="setCategory(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedCategory == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

  props: {
    listType: {
      type: String,
      default: '',
    }
  },

  data: () => ({
    materials: {
      kyokasho: [
        {id: 1, text: '見出し語問題', type: 'midashi', disabled: false},
        {id: 2, text: '応用問題', type: 'ouyou', disabled: false},
      ],
      getthrough: [
        {id: 1, text: '見出し語問題', type: 'midashi', disabled: false},
        {id: 2, text: '応用問題', type: 'ouyou', disabled: false},
        {id: 3, text: 'テーマ別', type: 'theme', disabled: false},
      ]
    }
  }),

  computed: {
    selectedCategory() {
      return this.$store.state.conditions.selectedCategory;
    }
  },

  mounted() {
  },

  methods: {
    setCategory(index) {
      this.$store.commit('conditions/setSelectedCategory', {
        category: index
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px
</style>
